export const iconFontAwesomeMapsBookmark = (
	<i className="fa-solid fa-bookmark"></i>
);
